<div class="landing_page_container">
  <mat-drawer-container class="sidenav-container" [hasBackdrop]="false">
    <mat-drawer #drawer class="table-sidenav-drawer" mode="over" position="end">
      <div class="side_nav_content_table"></div>
    </mat-drawer>
    <mat-drawer-content style="width: 100%">
      <div class="table_action_header mt-3">
        <div class="table_action_header_left">
          <label class="name_label"> Conversion Pixels </label>
        </div>

        <div>
          <span class="warning_message text-center">
            Conversion Pixels are used to track event driven conversions such as button clicks
          </span>
        </div>

        <div class="table_action_header_right">
          <div class="table_action_cell" *ngIf="showSearchInput">
            <mat-form-field
              style="width: auto"
              class="no-padding"
              appearance="outline"
            >
              <input
                matInput
                class="placeholders"
                placeholder="Search"
                (keyup)="searchPixel($event)"
                #input1
              />
              <mat-icon
                matSuffix
                class="material-icons search_icon"
                (click)="showSearchInput = false"
                >search</mat-icon
              >
            </mat-form-field>
          </div>

          <div class="table_action_cell" *ngIf="!showSearchInput">
            <button
              mat-button
              class="search-btn"
              (click)="showSearchInput = true"
            >
              <i class="material-icons search-btn-icon"> search </i>
            </button>
          </div>

          <div *ngIf="createPermission" class="table_action_cell">
            <button
              mat-button
              class="create-btn create-btn-io"
              (click)="
                commonService.createNew(
                  globalParams,
                  userRole,
                  createPath,
                  advertiserId,
                  null,
                  agcAdvId
                )
              "
            >
              <i class="material-icons add_create_button_icon me-1"> add </i
              >CREATE NEW
            </button>
          </div>
        </div>
      </div>

      <div class="resizable-table-container mb-3">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="landing-page-table"
        >
          <ng-container matColumnDef="checkbox">
            <th
              mat-header-cell
              *matHeaderCellDef
              columnResize
              [fixedIndex]="1"
              class="fixed-column-1"
            >
              <div class="table-checkboxes">
                <mat-checkbox
                  [checked]="allSelectedPixels"
                  [indeterminate]="isPixelSelected()"
                  (change)="selectAllPixels($event.checked)"
                >
                </mat-checkbox>
              </div>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              [style.color]="row.color"
              class="fixed-column-1"
            >
              <div class="table-checkboxes">
                <mat-checkbox
                  [(ngModel)]="row.selected"
                  (ngModelChange)="getSelectedPixels()"
                >
                </mat-checkbox>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              columnResize
              [fixedIndex]="3"
              class="fixed-column-3"
              (click)="onHeaderClick($event)"
            >
              <span class="table_header_name"> ID</span>
            </th>
            <td mat-cell *matCellDef="let row" class="fixed-column-3">
              <span class="table_value_name"> {{ row.id }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              columnResize
              [fixedIndex]="2"
              class="fixed-column-2"
              (click)="onHeaderClick($event)"
            >
              <span class="table_header_name"> Name</span>
            </th>
            <td mat-cell *matCellDef="let row" class="fixed-column-2">
              <span *ngIf="viewPermission" class="table_value_name">
                <a
                  [queryParams]="globalParams"
                  style="color: black"
                  [state]="{ edit_name: row.name }"
                  [routerLink]="['/tdsp/conversion-pixel/' + row.id + '/edit/']"
                  queryParamsHandling="merge"
                  >{{ row.name }}</a
                >
              </span>
              <span *ngIf="!viewPermission" class="table_value_name">
                {{ row.name }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="modified_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header columnResize (click)="onHeaderClick($event)">
              <span class="table_header_name">Last Modified</span>
            </th>
            <td mat-cell *matCellDef="let row" [style.color]="row.color">
              <span class="table_value_name">
                {{ row.modified_at.split(" ")[0] | date }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="last_hit_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header columnResize (click)="onHeaderClick($event)">
              <span class="table_header_name">Last Fire</span>
            </th>
            <td mat-cell *matCellDef="let row" [style.color]="row.color">
              <span class="table_value_name">
                {{ row.last_hit_at | date:'yyyy-MM-dd HH:mm:ss' }}

              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>
              <span class="table_header_name">
                <mat-icon
                  class="action_more_vert cursor_pointer"
                  [matMenuTriggerFor]="searchMenu"
                  >more_vert</mat-icon
                >
              </span>
            </th>
            <mat-menu #searchMenu="matMenu" role="menuitemcheckbox">
              <ng-template matMenuContent>
                <span class="select_column_heading">Select Columns</span>
                <div>
                  <mat-selection-list
                    (mouseleave)="closeSelectionList()"
                    (click)="$event.stopPropagation()"
                    class="header-options"
                    [(ngModel)]="columns"
                  >
                    <mat-list-option
                      *ngFor="let item of columnOptions"
                      [value]="item.value"
                      checkboxPosition="before"
                      [hidden]="
                        item.value == 'checkbox' ||
                        item.value == 'action' ||
                        item.value == 'name'
                      "
                    >
                      <span mat-menu-item style="text-transform: capitalize">
                        {{ item.label }}</span
                      >
                    </mat-list-option>
                  </mat-selection-list>
                </div>
              </ng-template>
            </mat-menu>
            <td mat-cell *matCellDef="let row" [style.color]="row.color">
              <span
                *ngIf="viewPermission || deletePermission"
                class="table_value_name"
              >
                <mat-icon
                  class="action_more_vert cursor_pointer"
                  [matMenuTriggerFor]="menu"
                  >more_vert</mat-icon
                >
              </span>
              <mat-menu #menu="matMenu" [overlapTrigger]="false">
                <span
                  *ngIf="viewPermission"
                  mat-menu-item
                  [queryParams]="globalParams"
                  [state]="{ edit_name: row.name }"
                  routerLink="/tdsp/conversion-pixel/{{ row.id }}/edit/"
                >
                  <span class="actions">
                    {{ editPermission ? "Edit" : "View" }}
                  </span>
                </span>
                <span mat-menu-item (click)="openPopUp(row.id)">
                  <span class="actions"></span>
                  Get Tag
                </span>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="13">No data matching the filter</td>
          </tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[10, 15, 25, 100]" (page)="handlePageEvent($event)" [length]="pageLength">
      </mat-paginator>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
